import { Link } from "react-router-dom";
import { propsRecuadroNovedad } from "../../models/Novedades.model";
import { pathImages } from "../../routes/endpoints";
import Sin_imagen from '../../assets/images/sin_imagen.png'; 
import { base_url } from "../../constants";

export default function Recuadro_novedad(props: propsRecuadroNovedad) {
    let imagen = (props.imagen === null || props.imagen === '')?Sin_imagen:pathImages+props.imagen;    
    return(
        <div className={props.claseDiv}>
            <div className="books_container">
                <Link to={`/${base_url}/obras/${props.id}`}>
                    <div className="row">
                        <div className="col-sm-5 text-center d-flex justify-content-center align-items-center img_books_general">
                            <img src={`${imagen}`} alt="" className="img-fluid"/>
                        </div>
                        <div className="col-sm-7 ps-3" style={{fontSize: "1rem", lineHeight: "1.3rem"}}>
                            <div className="row text-center text-sm-start books_container_parrafo">
                                <div className="col-12"><h3 className="mb-3"><div dangerouslySetInnerHTML={{__html: `${props.titulo}` }}></div> </h3></div>
                                {(props.tipo === 1)&&
                                <div className="col-12">
                                    <span>Año de publicación: {props.anio}</span>
                                </div>}
                                {(props.colaboradores)?
                                <div className="col-12">
                                    <span>Colaboradores:</span>
                                    <p className="mb-0">{props.colaboradores}</p>
                                </div>
                                :''}
                                {(props.autores)?
                                <div className="col-12 mt-3">
                                    <span>Autores:</span>
                                    <p className="mb-0" dangerouslySetInnerHTML={{__html: `${props.autores}` }}></p>
                                </div>
                                :''}
                                {(props.coordinadores)?
                                <div className="col-12 mt-3">                                    
                                    <span>Coordinadores:</span>
                                    <p className="mb-0">{props.coordinadores}</p>
                                </div>
                                :''}
                            </div>
                        </div>
                    </div>
                </Link>
            </div>
        </div>
    )
} 